import styled from 'styled-components';

import { adSlotConfig } from '../../ad-slot-config';
import { useDefineSlot } from '../use-define-slot';

const AdContainer = styled.div`
  height: 280px;
  margin: 0 auto;
`;

export const DisplayAdStartpageRectangle01: React.FC<{ refresh: boolean }> = ({
  refresh,
}) => {
  const { id, adUnitPath, size } = adSlotConfig.Startpage.Rectangle01;
  useDefineSlot({ id, adUnitPath, size, refresh });

  return <AdContainer id={id} />;
};
